import type { AssetFetchClient } from '@pkg/datasource-client'
import z from 'zod'

export const fetchSymbolAssetMap = async (params: {
  assetFetchClient: AssetFetchClient
  category: string
}): Promise<Record<string, string>> => {
  const { assetFetchClient, category } = params
  const response = await assetFetchClient.get(`/symbols/${category}.json`)
  if (!response.ok) {
    if (response.status === 404) {
      return {}
    }
    throw new Error(
      `Failed to fetch symbol asset map: ${response.status} ${response.statusText}`,
    )
  }
  return z.record(z.string()).parse(await response.json())
}
